import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { FB_PIXEL } from 'config/env';

document.title = process.env.REACT_APP_TITLE || 'PodoUP!';

const fbMeta = document.createElement('meta');
fbMeta.setAttribute('name', 'facebook-domain-verification');
fbMeta.setAttribute('content', FB_PIXEL);
document.head.appendChild(fbMeta);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
